<template>
  <nav class="navbar mb-topnav">
    <div v-if="loggedIn" class="nav-item d-lg-none">
      <button class="btn btn-light" @click="$emit('toggle-sidebar')">
        <font-awesome-icon icon="bars" />
      </button>
    </div>

    <div class="topnav-logo">
      <a href="/"><img src="/images/mixbrite_logo_wide_29.svg" class="topnav-image" /></a>
      <a href="/"><img src="/images/mixbrite_logo_mobile.svg" class="topnav-image-mobile" /></a>
    </div>

    <div class="nav-item topnav-headline d-none d-lg-block">
      <NavBarTitle class="top-bar-middle"/>
    </div>

    <div v-if="loggedIn" class="nav-item dropdown my-2 my-lg-1 mx-1">
      <a class="nav-link dropdown-toggle dot" href="#" id="navbarDropdown" role="button"
         data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{ initials }}
      </a>
      <ul class="dropdown-menu dropdown-menu-end">
        <li>
          <form action="/users/sign_out" method="post" class="d-inline">
            <input type="hidden" name="_method" value="delete" />
            <input type="hidden" name="authenticity_token" :value="csrfToken" />
            <button type="submit" class="dropdown-item">Sign Out</button>
          </form>
        </li>
        <li><a href="/users/deactivate" class="dropdown-item">Delete account</a></li>
      </ul>
    </div>

    <div v-else class="d-flex flex-row my-0 me-4 nav-buttons">
      <span class="navbar-text-link">
        <a href="/users/sign_up" class="btn btn-primary">Sign Up</a>
      </span>
      <span class="navbar-text-link">
        <a href="/users/sign_in" class="btn btn-secondary">Log In</a>
      </span>
    </div>
  </nav>
  <div class="mobile-headline d-lg-none">
    <NavBarTitle />
  </div>
</template>

<script>
import NavBarTitle from './nav_bar_title.vue'

export default {
  components: { NavBarTitle },
  emits: ['toggle-sidebar'],
  computed: {
    loggedIn() {
      return window.mmmGlobals?.logged_in || false
    },
    initials() {
      const name = window.mmmGlobals?.username || ''
      return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    },
    csrfToken() {
      return document.querySelector('meta[name="csrf-token"]')?.content || ''
    }
  }
}
</script>
